import { Avatar } from "antd";
import UserService from "services/UserService";

const HeaderMenusItems = () => {
	const userRole = UserService?.hasRole(['app-manager']);
	let lang=localStorage.getItem("language")   
	const headerMenus: any = userRole ? [
		{
			'icon': '',
			'label': lang || 'Language',
			'key': 'translation',
			'type': 'select',
			'value': 'en',
			'items': [
				{
					'icon': '',
					'label': 'English',
					'key': 'en',
				},
				{
					'icon': '',
					'label': 'Finnish',
					'key': 'fi',
				},
			]
		},
		{
			'icon': <Avatar src="#" style={{ backgroundColor: '#fde3cf', marginRight: "10px" }} />,
			'label': UserService.getUsername(),
			'key': 'user',
			'items': [
				{
					'icon': '',
					'label': 'Logout',
					'key': 'logout',
				},
			]
		},
	] : 
	[
		{
			'icon': '',
			'label': 'Target Group',
			'key': 'housingcompany',
		},
		{
			'icon': '',
			'label': 'Tenders',
			'key': 'tenders',
		},
		{
			'icon': '',
			'label': 'Administration',
			'key': 'administration',
			'items': [
				{
					'label': 'Import',
					'key': 'import',
				},
				{
					'label': 'Bank management',
					'key': 'banks',
				},
				{
					'label': 'File management',
					'key': 'manage-files',
				},
				{
					'label': 'Logs',
					'key': 'logs',
				},
			]
		},
		{
			'icon': '',
			'label': lang || 'Language',
			'key': 'translation',
			'type': 'select',
			'value': 'en',
			'items': [
				{
					'icon': '',
					'label': 'English',
					'key': 'en',
				},
				{
					'icon': '',
					'label': 'Finnish',
					'key': 'fi',
				},
			]
		},
		{
			'icon': <Avatar src="#" style={{ backgroundColor: '#fde3cf', marginRight: "10px" }} />,
			'label': UserService.getUsername(),
			'key': 'user',
			'items': [
				{
					'icon': '',
					'label': 'Logout',
					'key': 'logout',
				},
			]
		},
	]
	return (headerMenus);
}

export default HeaderMenusItems;
